<template>
  <div>
    <div class="text-caption pl-6 primary-grey--text font-weight-normal">
      <i>
        AI generated content may contain errors. Verify accuracy.
        <a
          @click="openDisclaimer"
        >
          <b>Read more</b>
        </a>
      </i>
    </div>

    <component
      :is="component"
      v-model="showFullDisclaimer"
      :scrollable="$isMobile"
      max-width="720"
    >
      <v-card class="d-flex flex-column">
        <v-card-title class="primary-grey--text d-flex align-center">
          <span>Sinoa AI Disclaimer</span>
          <v-spacer />
          <v-btn
            icon
            @click="closeDisclaimer"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="primary-grey--text pt-4">
          <p>
            Sinoa is designed to provide grain market insights and help you make sense of market trends.
            It does this by using large language models, a type of generative artificial intelligence (AI),
            which have been trained on data relevant to this context.
          </p>

          <p class="mt-3">
            While it can give helpful context, its answers may not always be accurate, complete, or up to date.
            AI can occasionally produce inaccuracies, and is dependent on the prompts you use, so you should not
            rely on it as your only source of information when making important farming, marketing, or financial
            decisions. For decisions about your farm or business, be sure to confirm information with trusted
            advisors or professionals and seek their advice. Sinoa is not a replacement for industry standard
            field monitoring, data management, and farm management practices. You should assess whether you
            require additional information and, where appropriate, consult your agronomist, commodities broker
            and other service professionals before making any decisions.
          </p>

          <p class="mt-3">
            The marketing of grain, oilseed, and special crop production involves considerable risk and
            notwithstanding the information and services we provide, you are solely responsible for your
            decisions and their consequences. {{ $appName }} Corp. is not legally liable to any person for damages
            related to the use of or reliance on Sinoa or the services or the information contained Sinoa.
            View more important information about capability and liability in our General Disclaimer and
            End User Licence Agreement.
          </p>

          <p class="mt-3">
            <a
              :href="termsUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="terms-link"
            >
              {{ termsUrl }}
            </a>
          </p>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="closeDisclaimer"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </component>
  </div>
</template>

<script>
import VBottomSheet from 'vuetify/lib/components/VBottomSheet';
import { COLORS } from '../../helpers/colors';

export default {
  name: 'SinoaDisclaimer',

  components: {
    VBottomSheet,
  },

  data() {
    return {
      showFullDisclaimer: false,
      termsUrl: 'https://www.grainfox.ca/terms/',
      COLORS,
    };
  },

  computed: {
    component() {
      return this.$isMobile ? 'v-bottom-sheet' : 'v-dialog';
    },
  },

  methods: {
    openDisclaimer() {
      this.showFullDisclaimer = true;
    },
    closeDisclaimer() {
      this.showFullDisclaimer = false;
    },
  },
};
</script>
